import styled from 'styled-components';
import {
  Caption,
  Colors,
  H3Heavy,
  HotDealsCarousel,
  Icon,
  MediaQuery,
  Theme,
} from '@pelando/components';

export const Container = styled.div`
  grid-area: hotdeal;
  width: 100%;
  padding: 16px 16px 0;
  overflow-x: hidden;
  margin-bottom: 16px;
  border-top: 4px solid rgb(${Theme.colors.Juliet});

  @media ${MediaQuery.SCREEN_LG_UP} {
    border-top: 1px solid rgb(${Theme.colors.Golf});
    border-top: 0;
    padding: 32px 0 0;
    margin-bottom: 0;
  }
`;

export const CustomCarousel = styled(HotDealsCarousel)`
  div::before {
    color: rgb(${Theme.colors.Kilo});
  }
`;

export const HotDealsHeader = styled.div`
  margin-bottom: 16px;
`;

export const HotDealsTitle = styled.h3`
  display: flex;
  flex-direction: row;
  ${H3Heavy}
`;

export const HotDealsDescription = styled.span`
  ${Caption}

  margin-left: 4px;
  margin-top: 4px;
  color: rgb(${Colors.Gray});
`;

export const HotDealsIcon = styled(Icon)`
  font-size: 24px;
  color: rgb(${Theme.colors.Brand});
`;
